import React, { useState, useEffect } from "react";
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image";
import MarketoForm from '../marketo/marketoForm';
import '../../sass/components/flexibleModules/_components.halfHalfMarketocomponent.scss';

const HalfHalfMarketocomponent = ({ data, graphData }) => {

    const [thankYouHash, setThankYouHash] = useState(false);
    const [thankYouHashAdra, setThankYouHashAdra] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            if (typeof window !== "undefined") {
                if (window.location.hash === '#ty') {
                    setThankYouHash(true);
                }
                if (window.location.hash === '#adra') {
                    setThankYouHashAdra(true);
                }
            }
        }, 10);
    });

    return (
        <div className="cp-halfHalfMarketocomponent" style={{ backgroundColor: `${data.backgroundColor}` }}>
            {data.overrideClass &&
                <>
                    {data.overrideClass.includes('l-newPatterns') &&
                        <>
                            <span className="l-absoluteNewIcon l-absoluteNewIcon1">
                                <StaticImage src="../../images/icon-yellow.png" alt="pattern" />
                            </span>
                            <span className="l-absoluteNewIcon l-absoluteNewIcon2">
                                <StaticImage src="../../images/icon-ultraviolet.png" alt="pattern" />
                            </span>
                            <span className="l-absoluteNewIcon l-absoluteNewIcon3">
                                <StaticImage src="../../images/icon-green.png" alt="pattern" />
                            </span>
                        </>
                    }
                </>
            }
            <div className={`cp-halfHalfMarketocomponent__inner l--flex ${data.overrideClass ? data.overrideClass : "l-noOverride"}`} style={{ maxWidth: `${data.maxWidth ? (data.maxWidth / 16 + "rem") : ""}`, margin: "0 auto" }}>
                <div className="cp-halfHalfMarketocomponent__left">
                    {data.halfAndHalfWithMarketoSubHeader &&
                        <h4>{data.halfAndHalfWithMarketoSubHeader}</h4>
                    }
                    {data.halfAndHalfWithMarketoHeader &&
                        <h2>{data.halfAndHalfWithMarketoHeader}</h2>
                    }
                    {data.halfAndHalfWithMarketoContent &&
                        <div dangerouslySetInnerHTML={{ __html: data.halfAndHalfWithMarketoContent }} />
                    }
                    {data.halfAndHalfWithMarketoImage &&
                        <>
                            {!thankYouHashAdra && thankYouHashAdra &&
                                <GatsbyImage image={getImage(data.halfAndHalfWithMarketoImage.gatsbyImage)} alt={data.halfAndHalfWithMarketoImage.altText} />
                            }
                        </>
                    }
                </div>
                <div className="cp-halfHalfMarketocomponent__right">
                    {thankYouHashAdra ?
                        <>
                            {data.halfAndHalfWithMarketoImage &&
                                <GatsbyImage image={getImage(data.halfAndHalfWithMarketoImage.gatsbyImage)} alt={data.halfAndHalfWithMarketoImage.altText} />
                            }
                        </>
                        :
                        <>
                            {data.halfAndHalfWithMarketoFormId &&
                                <div className="l--inner">
                                    {data.halfAndHalfWithMarketoFormHeader ?
                                        <h3>{data.halfAndHalfWithMarketoFormHeader}</h3>
                                        :
                                        <h3>See What's Possible in Planful</h3>
                                    }
                                    {data.halfAndHalfWithMarketoFormTeaser &&
                                        <p>{data.halfAndHalfWithMarketoFormTeaser}</p>
                                    }
                                    {thankYouHash ?
                                        <>
                                            {data.halfAndHalfWithMarketoSubmitMessage &&
                                                <p className="l-defaultMarketoMessage" dangerouslySetInnerHTML={{ __html: data.halfAndHalfWithMarketoSubmitMessage }}></p>
                                            }
                                            {data.halfAndHalfWithMarketoFormPdf &&
                                                <a download href={data.halfAndHalfWithMarketoFormPdf.mediaItemUrl} target="_blank" rel="noreferrer" className="l-button l--flex"><span>Download</span><span><StaticImage src="../../images/icon-rightArrowWhite.svg" alt=""></StaticImage></span></a>
                                            }
                                        </>
                                        :
                                        <MarketoForm formSubmitPdf={data.halfAndHalfWithMarketoFormPdf} wistiaVideoId={data.halfAndHalfWithMarketoWistiaVideoId} ctaOverride={data.halfAndHalfWithMarketoCtaOverride} formID={data.halfAndHalfWithMarketoFormId} formSubmitMessage={data.halfAndHalfWithMarketoSubmitMessage} />
                                    }
                                </div>
                            }
                        </>
                    }
                </div>
            </div>
        </div>
    );
}

export default HalfHalfMarketocomponent;